import { useState, useEffect } from 'react';
import { jsonReader } from '../helpers/tools';

const INTERVAL_MS = 5000;
const CDN = process.env.REACT_APP_CDN_URL || '';

function Hero() {
    const [images, setImages] = useState([]);
    const [current, setCurrent] = useState(0);

    useEffect(() => {
        jsonReader('hero.json').then(data => {
            if (Array.isArray(data)) setImages(data);
        });
    }, []);

    useEffect(() => {
        if (images.length <= 1) return;
        const t = setInterval(() => setCurrent(i => (i + 1) % images.length), INTERVAL_MS);
        return () => clearInterval(t);
    }, [images.length]);

    if (!images.length) return null;

    return (
        <div className="hero">
            {images.map((src, i) => (
                <div
                    key={src + i}
                    className={`heroSlide${i === current ? ' heroSlide--active' : ''}`}
                    style={{ backgroundImage: `url(${CDN + src})` }}
                />
            ))}
            <div className="heroGradient" />
        </div>
    );
}

export default Hero;
